import * as React from 'react';
const SmagliatureIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M115.19 126.11s5.8.24 8.77-2.49M76.51 116.49s4.89 2.32 11.65 2.07M90.74 123.84s5.52 1.03 10.62-.7M110.06 119.68s5.25-.74 8.77-2.24M75.35 126.01s3.27 2.4 8.88 2.61"
      className="prefix__cls-1"
    />
    <path
      d="M127.76 64.07c0 6.53-1.63 16.47-1.63 21.23 0 19.6 11.43 24.49 11.43 50.62M72.24 64.07c0 6.53 1.63 16.47 1.63 21.23 0 19.6-11.43 24.49-11.43 50.62M100 103.27s-3.13 2.45 0 4.9"
      className="prefix__cls-2"
    />
  </svg>
);
export default SmagliatureIcon;
